// extracted by mini-css-extract-plugin
export default {"approvalUnitFormContainer":"ApprovalUnitsForm_approvalUnitFormContainer__EAPq6","inputContainer":"ApprovalUnitsForm_inputContainer__ae8O-"};